import { Outlet, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import { useToken } from './useToken';
import { useRole } from '../../hooks/useRole';
import { isTokenInitialized } from '../../util/tokenManager';
import GradientLogo from '../../../public/icons/GradientLogo';
import LoadingCircle from '../assetComponents/LoadingCircle';


export default function AdminPrivateRoute({
  children,
  requiredRole = 'moderator',
}) {
  const [isLoading, setIsLoading] = useState(false);
  const [token] = useToken();
  const { role, hasModeratorAccess, hasAdminAccess, hasSuperAdminAccess } =
    useRole();

  useEffect(() => {
    // Only show loading if we think there might be a token coming
    if (!isTokenInitialized() && !token) {
      setIsLoading(true);

      // Short timeout for loading
      const timer = setTimeout(() => {
        setIsLoading(false);
      }, 300);

      return () => clearTimeout(timer);
    } else {
      setIsLoading(false);
    }
  }, [token]);

  // Show loading screen during token initialization
  if (isLoading && !token && !isTokenInitialized()) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          flexDirection: 'column',
        }}>
        {/* <GradientLogo svgClass={'splash-logo'} /> */}
        <LoadingCircle />

      </div>
    );
  }

  // Check role-based access first
  const hasRequiredAccess = () => {
    switch (requiredRole) {
      case 'moderator':
        return hasModeratorAccess;
      case 'admin':
        return hasAdminAccess;
      case 'super_admin':
        return hasSuperAdminAccess;
      default:
        return hasModeratorAccess;
    }
  };

  // If role is available and user has required access, allow access regardless of token state
  if (role && role !== 'user' && hasRequiredAccess()) {
    return children || <Outlet />;
  }

  // If no role or insufficient access, check token state
  if (!token || (isTokenInitialized() && !token)) {
    return <Navigate to='/swapandtop/login' replace />;
  }

  // If user doesn't have required role, redirect to main app
  if (role && !hasRequiredAccess()) {
    return <Navigate to='/swapandtop/' replace />;
  }

  // If token exists but role is still being determined, show loading
  if (token && !role) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          flexDirection: 'column',
        }}>
        <LoadingCircle />
        {/* <GradientLogo svgClass={'splash-logo'} /> */}
        {/* <div style={{ marginTop: '20px', fontSize: '18px' }}>Loading...</div> */}
      </div>
    );
  }

  // Render the protected admin content
  return children || <Outlet />;
}
